export default "__VITE_ASSET__Bo2hAT_B__"